module.exports = __webpack_public_path__ + "img/test_bg.fa558d0c.png";